import { useMemo } from 'react'
import moment from 'moment'
import { Files as FS } from '@constants'

const Formatter = ({ children, data, filter, query }) => {
  // no need for this weird substractions, if else takes care of it, might not even need between but just more than
  // no need for so many expansions either, using just foreach might also be a better idea
  const now = moment(moment.now()).startOf('day').toISOString()

  const { today, yesterday, week, month, year } = useMemo(() => {
    return {
      today: [moment(now).startOf('day'), moment(now).endOf('day')],
      yesterday: [
        moment(now).startOf('day').subtract(1, 'days'),
        moment(now).endOf('day').subtract(1, 'days')
      ],
      week: [
        moment(now).startOf('day').subtract(6, 'days'),
        moment(now).endOf('day').subtract(2, 'days')
      ],
      month: [
        moment(now).startOf('day').subtract(29, 'days'),
        moment(now).endOf('day').subtract(7, 'days')
      ],
      year: moment(moment.now()).startOf('year')
    }
  }, [now])

  const filtered = useMemo(
    () =>
      data
        .filter(({ data }) =>
          filter.type
            ? FS.SUPPORTED_FILE_TYPES[filter.type].includes(data.type)
            : true
        )
        .filter(({ data }) =>
          filter.participants.length
            ? filter.participants.reduce(
                (acc, id) => data.participants[id] || acc,
                false
              )
            : true
        )
        .filter(({ data }) => {
          return data.name.toLowerCase().includes(query.toLowerCase())
        }),
    [data, filter.participants, filter.type, query]
  )

  const formatted = useMemo(
    () =>
      filtered.reduce((acc, v) => {
        const createdAt = moment(v.data.createdAt)
        if (createdAt.isBetween(...today, null, '[]')) {
          return { ...acc, today: [...(acc.today ? acc.today : []), v] }
        } else if (createdAt.isBetween(...yesterday, null, '[]')) {
          return {
            ...acc,
            yesterday: [...(acc.yesterday ? acc.yesterday : []), v]
          }
        } else if (createdAt.isBetween(...week, null, '[]')) {
          return { ...acc, week: [...(acc.week ? acc.week : []), v] }
        } else if (createdAt.isBetween(...month, null, '[]')) {
          return { ...acc, month: [...(acc.month ? acc.month : []), v] }
        } else if (createdAt.isSameOrAfter(year)) {
          let year = [...(acc.year || new Array(12).fill([]))]
          year[createdAt.month()] = [...year[createdAt.month()], v]
          return { ...acc, year }
        } else {
          // here we need to map it to correct year, if the year is not present, create one
          let sometime = { ...(acc.sometime || {}) }
          sometime[createdAt.year()] = [
            ...(sometime[createdAt.year()] ? sometime[createdAt.year()] : []),
            v
          ]
          return { ...acc, sometime }
        }
      }, {}),
    [filtered, month, today, week, yesterday, year]
  )

  return children(formatted)
}

export default Formatter
